<template>
  <section class="w-full">
    <!-- <router-link :to="{ name: user + action }"> -->
    <div class="flex items-center px-2 py-1 space-x-2">
      <img
        class="inline object-cover w-8 h-8 rounded-full"
        :src="baseUrlSrc(thumbnail_url)"
        alt="Profile image"
        @error="defaultCircleImage"
      />
      <div class="text-sm capitalize text-gray-dark w-full">
        <div
          class="flex items-center justify-between text-gray-dark"
          v-if="notificationType == 'sendMessage'"
        >
          <p class="capitalize text-xs">
            {{ title }}
          </p>
          <span class="capitalize text-xs">{{
            createdAt && handleHour24(createdAt)
          }}</span>
        </div>
        <p class="text-gray-dark">
          <b v-if="notificationType != 'sendMessage'">{{ title }}</b>
          {{ body }}
        </p>
      </div>
    </div>
    <!-- </router-link> -->
  </section>
</template>

<script>
export default {
  name: "NotificationList",
  props: {
    title: {
      type: String,
    },
    body: {
      type: String,
    },
    action: {
      type: String,
    },
    thumbnail_url: {
      type: String,
    },
    notificationType: {
      type: String,
    },
    createdAt: {
      type: String,
    },
    user: {
      type: String,
    },
  },
  data() {
    return {};
  },
};
</script>